// src/modules/competition/components/CompetitorsTable/CompetitorsTableBody.js
import React from 'react';
import { ProgressBar, Tooltip, OverlayTrigger } from 'react-bootstrap';
import PropTypes from 'prop-types';

const CompetitorsTableBody = ({ competitors, lowestCompetitor, pointTarget, onUsernameClick }) => {
    return (
        <tbody>
            {competitors.map((competitor) => {
                const { username, firstName, lastName, totalPoints = 0, numActivities, rank } = competitor;
                const meetsCriteria = totalPoints >= pointTarget;
                const progress = (totalPoints / pointTarget) * 100;
                let specialSymbols = '';
                if (lowestCompetitor && lowestCompetitor.firstName === firstName) {
                    specialSymbols += '🍰';
                }
                if (rank <= 3) {
                    specialSymbols += ['🥇', '🥈', '🥉'][rank - 1];
                }

                return (
                    <tr
                        key={firstName}
                        onClick={() => onUsernameClick(username)}
                        className="clickable-row"
                        aria-label={`Competitor ${firstName}`}
                    >
                        <td style={{ fontWeight: rank <= 3 ? 600 : undefined }}>
                            {rank}
                        </td>
                        <td>
                            <span>
                                {specialSymbols} {firstName} {lastName}
                            </span>
                        </td>
                        <td>{totalPoints.toFixed(2)}</td>
                        <td>{numActivities}</td>
                        <td>
                            <div className="d-flex align-items-center">
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        !meetsCriteria ? (
                                            <Tooltip id={`tooltip-${firstName}`}>
                                                {`${(pointTarget - totalPoints).toFixed(2)} points remaining`}
                                            </Tooltip>
                                        ) : (
                                            <Tooltip id={`tooltip-${firstName}`}>Achieved point target!</Tooltip>
                                        )
                                    }
                                >
                                    <ProgressBar
                                        now={progress}
                                        variant={meetsCriteria ? "success" : "warning"}
                                        style={{ flex: 1, cursor: 'pointer' }}
                                        aria-label={`Progress for ${firstName}`}
                                    />
                                </OverlayTrigger>
                                {meetsCriteria ? <span className="ms-2">✅</span> : <span className="ms-2">❌</span>}
                            </div>
                        </td>
                    </tr>
                );
            })}
        </tbody>
    );
};

CompetitorsTableBody.propTypes = {
    competitors: PropTypes.arrayOf(PropTypes.shape({
        username: PropTypes.string.isRequired,
        firstName: PropTypes.string.isRequired,
        totalPoints: PropTypes.number.isRequired,
        numActivities: PropTypes.number.isRequired
    })).isRequired,
    lowestCompetitor: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        profilePicture: PropTypes.string,
        totalPoints: PropTypes.number.isRequired
    }),
    pointTarget: PropTypes.number.isRequired,
    onUsernameClick: PropTypes.func.isRequired
};

export default CompetitorsTableBody;
